var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.documents),function(ref){
var title = ref.title;
var subTitle = ref.subTitle;
var pos = ref.pos;
return _c('li',{key:pos,staticClass:"list__item"},[_c('document-icon',{staticClass:"list__icon"}),_vm._v(" "),_c('a',{staticClass:"list__link",attrs:{"href":("/" + _vm.path + "/" + subTitle),"rel":"noreferrer noopener","target":"_blank"}},[_vm._v("\n      "+_vm._s(title)+"\n    ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }